import {createRouter, createWebHashHistory} from "vue-router";
import Home from "../views/home.vue"
import Designfood from "../views/designfood.vue"
import Register from "../views/register.vue"
import Login from "../views/login.vue"
import EmailMessage from "../views/emailMessage.vue"
import Update from "../views/update.vue"
import Undefine from "../views/U404.vue"

const routes = [
    {
        path: '/',
        redirect: '/home'
    }, {
        path: "/home",
        name: "Home",
        component: Home,
        meta: {
            title: '首頁'
        },
        children: []
    }, {
        path: "/designfood",
        name: "Designfood",
        component: Designfood,
        meta: {
            title: '創意中餐'
        },
        children: []
    }, {
        path: "/register",
        name: "Register",
        component: Register,
        meta: {
            title: '成為會員'
        },
        children: []
    }, {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
            title: '成為會員'
        },
        children: []
    }, {
        path: "/emailMessage",
        name: "EmailMessage",
        component: EmailMessage,
        meta: {
            title: '成為會員'
        },
        children: []
    },{
        path: "/update",
        name: "Update",
        component: Update,
        meta: {
            title: '成為會員'
        },
        children: []
    },{
        path: '/undefine',
        name: 'Undefine',
        component: Undefine,
        meta: {
            title: '404'
        },
        children: []
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

router.beforeEach((to, from, next) => {
    let a = ['/','/home','/designfood','/register','/login','/emailMessage','/update','/undefine']
    document.title = `${to.meta.title} | 營和味`;
    if(to.path != '/update') {
        window.localStorage.removeItem('AIIndex_Token')
    } 
    if (a.indexOf(to.path) > -1) {
        next()
    } else {
        next('/undefine')
    }
});
export default router;